<div *ngIf="problemDetail" class="alert alert-danger col-10 mx-auto">
  {{ problemDetail.detail }}
</div>

<vpa-unelected-vendor-error-modal *ngIf="showUnelectedVendorError"></vpa-unelected-vendor-error-modal>